// extracted by css-extract-rspack-plugin
export default {"properties":"OuDrPE"};